function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.11166 5.99274L2.3265 0.207681C2.19269 0.0737718 2.01408 0 1.82362 0C1.63317 0 1.45455 0.0737718 1.32075 0.207681L0.894712 0.633613C0.617487 0.911155 0.617487 1.36224 0.894712 1.63936L5.75266 6.4973L0.889322 11.3606C0.755518 11.4945 0.681641 11.6731 0.681641 11.8634C0.681641 12.054 0.755518 12.2325 0.889322 12.3665L1.31536 12.7923C1.44927 12.9262 1.62778 13 1.81823 13C2.00869 13 2.1873 12.9262 2.32111 12.7923L8.11166 7.00198C8.24578 6.86764 8.31945 6.68829 8.31903 6.49762C8.31945 6.30622 8.24578 6.12697 8.11166 5.99274Z",
  fill: "#072E4B"
});

var SvgBlackArrowRight = function SvgBlackArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/black-arrow-right.9cd9d635.svg";
export { ForwardRef as ReactComponent };